import { motion } from "framer-motion";
import { FaFileAlt, FaSearch, FaCheckCircle, FaMoneyCheckAlt } from "react-icons/fa";
import "./Process.css";

const steps = [
  { icon: FaFileAlt, title: "Apply", desc: "Submit your loan application online or in-branch." },
  { icon: FaSearch, title: "Document Verification", desc: "Our team verifies your documents and eligibility." },
  { icon: FaCheckCircle, title: "Loan Approval", desc: "Get a fast, transparent approval decision." },
  { icon: FaMoneyCheckAlt, title: "Receive Amount", desc: "Funds are disbursed directly to your account." },
];

const Process = () => {
  return (
    <section className="section lf-process">
      <div className="container">
        <div className="section-head-center">
          <span className="eyebrow">How It Works</span>
          <h2 className="section-heading">
            A Simple <span className="accent-text">4-Step</span> Process
          </h2>
          <p className="section-subtext">From application to funds in hand — quick and hassle-free.</p>
        </div>

        <div className="lf-process__timeline">
          <motion.div
            className="lf-process__line"
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
          />
          {steps.map(({ icon: Icon, title, desc }, i) => (
            <motion.div
              key={title}
              className="lf-process__step"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.6, delay: i * 0.18 }}
            >
              <span className="lf-process__number">0{i + 1}</span>
              <span className="lf-process__icon">
                <Icon />
              </span>
              <h4>{title}</h4>
              <p>{desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
